export default "__VITE_ASSET__D5A3n2Rf__"